import Table from './table.vue';

Table.install = function (Vue) {
  Vue.component(Table.name, Table);
};

export default Table;
